export function downloadDocument(fileToDownload: any, name?: string) {
    const link = document.createElement('a');
    const fileURL = URL.createObjectURL(fileToDownload);
    link.href = fileURL;
    link.download = name ? name : 'Report';
    link.click();
    link.remove();
}
